import {Icon, ListItemIcon, ListItemText, MenuItem} from "@mui/material";
import {logout} from "../../shared/keycloak";

function Logout() {
    function handleLogout() {
        logout();
    }

    return (
        <MenuItem onClick={handleLogout}>
            <ListItemIcon>
                <Icon fontSize="small">logout</Icon>
            </ListItemIcon>
            <ListItemText>Sair</ListItemText>
        </MenuItem>
    );
}

export default Logout;
